import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '@/lib/analytics';

/**
 * PageViewTracker component that automatically tracks page views
 * Add this component to your main App component or router
 */
export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever the route changes
    analyticsService.trackPageView(location.pathname + location.search);
  }, [location]);

  return null; // This component doesn't render anything
}

export default PageViewTracker;
